import "./SettingsCard.css";

export default function SettingsCard({ icon, title, description, children }) {
  return (
    <section className="settings-card">
      <div className="settings-card__header">
        {icon && <div className="settings-card__icon">{icon}</div>}

        <div>
          <h2>{title}</h2>
          {description && <p>{description}</p>}
        </div>
      </div>

      <div className="settings-card__body">{children}</div>
    </section>
  );
}
